exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".OrderPreview__previewContainer___2SL5Evk- {\n  width: 100%;\n  height: 100%;\n}\n.OrderPreview__previewContainer___2SL5Evk-::after {\n  content: '';\n  padding-top: 70%;\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"previewContainer": "OrderPreview__previewContainer___2SL5Evk-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/configurator/components/Preview/OrderPreview.vue?vue&type=style&index=0&module=true&lang=css&
// module id = 23EM
// module chunks = 3